module.exports = __webpack_public_path__ + "static/media/iceteam.e50fddcf.png";